import React from 'react'
import PageViewTracker from '../components/PageViewTracker'
import WhatsappWidget from '../components/common/WhatsappWidget'
import MontajNoktalari from '../pages/MontajNoktalari'
import MontajBasvuruForm from '../pages/MontajBasvuruForm'
import MontageThanks from '../pages/MontageThanks'
import ServiceThanks from '../pages/ServiceThanks'
import AracMontajBasvuru from '../pages/AracMontajBasvuru'
import UttsNedir from '../pages/UttsNedir'
import { TTS } from '../pages/TTS'
import SıkSorulanSorular from '../pages/SıkSorulanSorular'
import MusteriTemsilcisi from '../pages/MusteriTemsilcisi'
import Admin from '../pages/AdminPage'
import BasvuruDetay from '../pages/BasvuruDetay'
import MontageCancellation from '../pages/MontageCancellation'
import KvkkPage from '../pages/KVKK'
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom'
import Mevzuat from '../pages/Mevzuat'
import Hakkimizda from '../pages/Hakkimizda'
import Gizlilik from '../pages/Gizlilik'
import { AdminLoginPage, Dashboard, ForgotPasswordPage, InvitationPasswordPage, NotFound, ReferenceDetailPage, RefListPage, RefLoginPage, ReservationAllPage, ReservationDetailPage, ServiceApplicationList, ServiceDashboardPage, ServiceListPage, ServiceMyPage, ServiceProfilePage } from '../pages'
import ProspectPage from '../pages/admin/prospect/ProspectPage'
import DashboardPage from '../pages/admin/service-provider/DashboardPage'
import { PATHS } from './PATHS'
import { AdminLayout } from '../layout/AdminLayout'
import Home from '../pages/Home'

export default function AdminRoutes() {
  return (
    <>
      <PageViewTracker />
      <WhatsappWidget />
      <Routes>
        <Route index element={<Home />} />
        <Route
          path="/portal/utts-montaj-noktalari"
          element={<MontajNoktalari />}
        />
        <Route
          path="/portal/utts-montaj-basvuru"
          element={<MontajBasvuruForm />}
        />
        <Route path="/portal/thank-you-montage" element={<MontageThanks />} />
        <Route path="/portal/thank-you-service" element={<ServiceThanks />} />
        <Route
          path="/portal/utts-kayit-sureci"
          element={<AracMontajBasvuru />}
        />
        <Route path="/portal/utts-nedir" element={<UttsNedir />} />
        <Route path="/portal/utts-kittak-is-ortagi" element={<TTS />} />
        <Route
          path="/portal/utts-sık-sorulan-sorular"
          element={<SıkSorulanSorular />}
        />
        <Route
          path="/portal/utts-musteri-temsilcisi"
          element={<MusteriTemsilcisi />}
        />
        <Route path="/portal/kittak-admin" element={<Admin />} />
        <Route
          path="/portal/kittak-admin/basvuru/:id"
          element={<BasvuruDetay />}
        />
        <Route
          path="/portal/montaj/iptal/:id"
          element={<MontageCancellation />}
        />
        <Route path="/portal/kvkk" element={<KvkkPage />} />
        <Route path="/portal/mevzuat" element={<Mevzuat />} />
        <Route path="/portal/hakkimizda" element={<Hakkimizda />} />
        <Route path="/portal/gizlilik" element={<Gizlilik />} />

        <Route
          path="/portal/invitation/:token"
          element={<InvitationPasswordPage />}
        />
        <Route path={PATHS.admin.login} element={<AdminLoginPage />} />
        <Route path={PATHS.admin.prospect.root} element={<ProspectPage />} />
        <Route path={PATHS.admin.root} element={<Dashboard />} />
        <Route
          path={PATHS.admin.montageApplication.root}
          element={<Dashboard />}
        />
        <Route
          path={PATHS.admin.servicesProviders.root}
          element={<ServiceListPage />}
        />
        <Route path={PATHS.admin.dashboard} element={<DashboardPage />} />
        <Route
          path={PATHS.admin.servicesProviders.application}
          element={<ServiceApplicationList />}
        />
        <Route
          path={PATHS.admin.servicesProviders.profile.root}
          element={<ServiceProfilePage />}
        />
        <Route
          path={PATHS.admin.reservation.root}
          element={<ReservationAllPage />}
        />
        <Route
          path={PATHS.admin.reservation.detail.root}
          element={<ReservationDetailPage />}
        />

        <Route
          path={PATHS.admin.service.root}
          element={<ServiceDashboardPage />}
        />

        <Route
          path={PATHS.admin.service.profile.root}
          element={<ServiceMyPage />}
        />

        <Route path={PATHS.admin.referance.root} element={<RefListPage />} />

        <Route path={PATHS.ref.root} element={<ReferenceDetailPage />} />

        <Route path={PATHS.ref.login} element={<RefLoginPage />} />

        <Route path={PATHS.forgotPassword} element={<ForgotPasswordPage />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}
